export default ($scope) => {};
